import { render, staticRenderFns } from "./EmergencyList.vue?vue&type=template&id=622abb96&"
import script from "./EmergencyList.vue?vue&type=script&lang=js&"
export * from "./EmergencyList.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports